module.exports = __webpack_public_path__ + "img/paishui3.264fcc71.png";